<template>
  <div>
    <div class="tosContainer" ref="scroller" v-on:scroll="scrollCheck" v-html="termText"></div>
    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" :name="fieldName" :disabled="(scrollProgress < 1)" value="1" :id="fieldName">
        <label class="form-check-label" :for="fieldName">{{fieldLabel}}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fieldLabel: {
      type: String,
      default: 'I agree to these Terms and Conditions.',
    },
    fieldName: {
      type: String,
      default: 'tos_agree',
    },
    termText: String,
  },
  data: function() {
    return {
      scrollProgress: 0,
    };
  },
  methods: {
    scrollCheck: function(e) {
      this.scrollProgress = e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight);
    },
  },
}
</script>